const initialState = {
  websocket: null,
  websocketOnline: false,
};

const connectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CONNECTION_WEBSOCKET_LOADED_FROM_SESSION":
    case "CONNECTION_WEBSOCKET_LOGIN_SUCCESS":
      state = {
        ...state,
        websocket: action.payload.websocket,
      };
      break;
    case "CONNECTION_WEBSOCKET_ONLINE":
    case "CONNECTION_WEBSOCKET_OFFLINE":
      state = {
        ...state,
        websocketOnline:
          action.type === "CONNECTION_WEBSOCKET_ONLINE" ? true : false,
      };
      break;
    case "CONNECTION_WEBSOCKET_MSG":
      if (
        action.payload.msg.name === "LOGIN_RESPONSE" &&
        action.payload.msg.status === 0
      ) {
        state = {
          ...state,
          websocketOnline: true,
        };
      }
      if (
        action.payload.msg.name === "LOGIN_RESPONSE" &&
        action.payload.msg.status === 404
      ) {
        state = {
          ...state,
          websocketOnline: false,
        };
      }
      break;
    default:
      break;
  }
  return state;
};

export default connectionReducer;






// WEBPACK FOOTER //
// ./src/reducers/connectionReducer.js